<template>
  <div class="auth">
    <picture>
      <source srcset="@/assets/images/auth/glow.png" type="image/png" />
      <source srcset="@/assets/images/auth/glow.avif" type="image/avif" />
      <img alt="Auth Effect" width="1800" height="1800" src="@/assets/images/auth/glow.avif" class="auth-effect" />
    </picture>
    <div class="auth-container">
      <main class="auth-content my-auto">
        <div class="auth-card">
          <NuxtPage />
        </div>
        <div class="auth-background">
          <svg
            fill="none"
            viewBox="0 0 301 461"
            aria-hidden="true"
            class="absolute left-full top-16 ml-2 w-72 [mask-image:radial-gradient(circle_at_top_left,black,transparent_theme(spacing.72))]"
          >
            <g filter="url(#filter0_d_35_2)">
              <path
                fill="#fff"
                d="m4.705 141.252 36.53-37.442a6.002 6.002 0 0 1 4.294-1.81h102.409a6.002 6.002 0 0 0 4.334-1.851l91.581-95.673a6 6 0 0 1 4.334-1.851H292a6 6 0 0 1 6 6V452a6 6 0 0 1-6 6H9a6 6 0 0 1-6-6V145.442a6 6 0 0 1 1.705-4.19Z"
              />
            </g>
            <defs>
              <filter
                id="filter0_d_35_2"
                width="300"
                height="460.375"
                x=".5"
                y=".125"
                color-interpolation-filters="sRGB"
                filterUnits="userSpaceOnUse"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix>
                <feOffset></feOffset>
                <feGaussianBlur stdDeviation="1.25"></feGaussianBlur>
                <feComposite in2="hardAlpha" operator="out"></feComposite>
                <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"></feColorMatrix>
                <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_35_2"></feBlend>
                <feBlend in="SourceGraphic" in2="effect1_dropShadow_35_2" result="shape"></feBlend>
              </filter>
            </defs></svg
          ><svg
            fill="none"
            viewBox="0 0 301 461"
            aria-hidden="true"
            class="absolute right-full top-16 mr-2 w-72 -scale-x-100 [mask-image:radial-gradient(circle_at_top_left,black,transparent_theme(spacing.72))]"
          >
            <g filter="url(#filter0_d_35_2)">
              <path
                fill="#fff"
                d="m4.705 141.252 36.53-37.442a6.002 6.002 0 0 1 4.294-1.81h102.409a6.002 6.002 0 0 0 4.334-1.851l91.581-95.673a6 6 0 0 1 4.334-1.851H292a6 6 0 0 1 6 6V452a6 6 0 0 1-6 6H9a6 6 0 0 1-6-6V145.442a6 6 0 0 1 1.705-4.19Z"
              ></path>
            </g>
            <defs>
              <filter
                id="filter0_d_35_2"
                width="300"
                height="460.375"
                x=".5"
                y=".125"
                color-interpolation-filters="sRGB"
                filterUnits="userSpaceOnUse"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix>
                <feOffset></feOffset>
                <feGaussianBlur stdDeviation="1.25"></feGaussianBlur>
                <feComposite in2="hardAlpha" operator="out"></feComposite>
                <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"></feColorMatrix>
                <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_35_2"></feBlend>
                <feBlend in="SourceGraphic" in2="effect1_dropShadow_35_2" result="shape"></feBlend>
              </filter>
            </defs>
          </svg>
          <div class="absolute left-1/2 top-10 h-[9.25rem] w-[calc(100%+(10.125rem*2))] -translate-x-1/2 overflow-hidden">
            <div class="absolute left-1/2 h-[111px] w-[1216px] -translate-x-1/2">
              <svg fill="none" viewBox="0 0 1216 111" aria-hidden="true">
                <path
                  class="stroke-black/5"
                  d="M0 110h347.654a7.999 7.999 0 0 0 5.696-2.383L455.9 3.633a8.001 8.001 0 0 1 5.696-2.383h292.308c2.141 0 4.192.858 5.696 2.383l102.55 103.984a7.999 7.999 0 0 0 5.696 2.383H1216"
                ></path>
              </svg>
              <canvas class="absolute inset-0 h-full w-full" aria-hidden="true" width="1216" height="111"></canvas>
              <svg width="0" height="0" aria-hidden="true">
                <path
                  d="M0 110h347.654a7.999 7.999 0 0 0 5.696-2.383L455.9 3.633a8.001 8.001 0 0 1 5.696-2.383h292.308c2.141 0 4.192.858 5.696 2.383l102.55 103.984a7.999 7.999 0 0 0 5.696 2.383H1216"
                ></path>
              </svg>
            </div>
          </div>
        </div>
      </main>
      <footer class="auth-footer">
        <p class="text-gray-300 font-[450]">© 2025 EverŞarj</p>
        <ul role="list" class="flex gap-2">
          <li v-for="(item, index) in navigation" class="flex items-center gap-2 text-gray-300 hover:text-gray-400">
            <span class="text-xs text-gray-70 px-1" v-if="index > 0">/</span>
            <a :href="item.link" target="_blank">{{ item.title }}</a>
          </li>
        </ul>
      </footer>
    </div>
  </div>
</template>

<script setup lang="ts">
  const navigation = [
    {
      title: "İletişim",
      link: "https://eversarj.com/pages/iletisim"
    },
    {
      title: "Gizlilik Sözleşmesi",
      link: "https://eversarj.com/pages/kvkk"
    }
  ]
</script>

<style scoped>
  .auth {
    @apply relative flex min-h-screen flex-col items-center overflow-hidden bg-gray-40 px-4 py-6;

    &-container {
      @apply relative flex w-full max-w-[25rem] flex-1 flex-col justify-center gap-y-6;
    }
    &-card {
      margin: auto;
      position: relative;
      z-index: 100;
      display: flex;
      flex-flow: column;
      isolation: isolate;
      max-width: calc(-2.5rem + 100vw);
      width: 25rem;
      border-style: solid;
      border-color: rgba(0, 0, 0, 0.07);
      color: rgb(33, 33, 38);
      overflow: hidden;
      border-width: 0;
      box-shadow:
        rgba(0, 0, 0, 0.08) 0px 5px 15px 0px,
        rgba(25, 28, 33, 0.2) 0px 15px 35px -5px,
        rgba(0, 0, 0, 0.07) 0px 0px 0px 1px;
      background-color: white;
      @apply rounded-2xl p-6 sm:p-10 sm:pt-8;
    }
    &-content {
      @apply relative flex flex-col;
    }
    &-effect {
      @apply pointer-events-none absolute left-1/2 top-1/2 z-10 h-[150vh] max-w-none -translate-x-1/2 -translate-y-1/2 select-none mix-blend-overlay;
    }
    &-background {
      @apply pointer-events-none absolute inset-0;
    }
    &-footer {
      @apply flex justify-between;
    }
  }
</style>
